import type { VBaseTableColumnRenederer, VBaseTableData } from '../VBaseTable';
import { VFlex } from '../VFlex';
import { ArrowDownward, ArrowUpward } from '../asset';
import { useVTableContext } from './hook';

const SorterColumnRenderer = <T extends VBaseTableData>({
  columnId,
  columnRenderer,
}: {
  columnId: keyof T;
  columnRenderer: VBaseTableColumnRenederer<T>;
}) => {
  const { columnSorter, onColumnSorterChange } = useVTableContext();

  const originalRenderer = columnRenderer?.[columnId];
  const isDesc = columnSorter?.find(({ id }) => id === columnId)?.desc;
  const originalContent =
    typeof originalRenderer === 'function'
      ? originalRenderer(columnId)
      : String(columnId);

  const Icon = isDesc ? ArrowUpward : ArrowDownward;

  return (
    <VFlex
      items="center"
      gap={0.5}
      style={{ cursor: 'pointer' }}
      onClick={() => {
        const nextSorter = columnSorter?.map(sorter => {
          if (sorter.id !== columnId) return sorter;

          return { ...sorter, desc: !isDesc };
        });
        onColumnSorterChange?.(nextSorter ?? []);
      }}
    >
      {originalContent}
      <Icon className="size-4" />
    </VFlex>
  );
};

export default SorterColumnRenderer;
